// Proyectos de Veeva y IQVIA
export const veevaIqviaProjects = {
    ayudasVisuales: [{
            id: 101,
            name: 'Ayuda visual Kyprolis',
            title: 'Plataforma Veeva',
            description: 'La “Ayuda Visual Kyprolis” es una herramienta digital diseñada para presentar información médica y científica de manera visual e interactiva.',
            thumbnail: '/Imagenes/ayudas visuales/ayuda1.png',
            videoUrl: '/Imagenes/videos/video1.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 102,
            name: 'Ayuda visual Sanfer',
            title: 'Plataforma Veeva',
            description: 'Ayuda visual o material promocional médico de “Gamabenceno”, un tratamiento a base de permetrina al 5% utilizado para el manejo de la escabiosis (sarna). El contenido presenta información relacionada con su eficacia, seguridad, beneficios y guías de uso, dirigido principalmente a profesionales de la salud como apoyo educativo y comercial.',
            thumbnail: '/Imagenes/ayudas visuales/av1.png',
            videoUrl: '/Imagenes/videos/video2.mov',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 103,
            name: 'Ayuda visual Enterogermina',
            title: 'Plataforma OCE',
            description: 'Ayuda visual médica de “Enterogermina”, un probiótico utilizado para el cuidado de la salud intestinal. El material destaca su eficacia, seguridad y beneficios en el manejo de disbiosis intestinal y diarrea, comparándolo con otros probióticos y resaltando sus propiedades y mecanismos de acción.',
            thumbnail: '/Imagenes/ayudas visuales/oce1.png',
            videoUrl: '/Imagenes/videos/video prueba OCE.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 104,
            name: 'Ayuda visual Knight',
            title: 'Plataforma Veeva',
            description: 'Ayuda visual e interactiva sobre la dosificación y aplicación de Halaven (mesilato de eribulina). Está dirigida a profesionales de la salud y presenta información relacionada con indicaciones, preparación, administración, almacenamiento, precauciones y manejo de dosis del medicamento de forma clara y organizada.',
            thumbnail: '/Imagenes/ayudas visuales/veeva2.png',
            videoUrl: '/Imagenes/videos/vdieo3.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 105,
            name: 'Ayuda visual Cosentyx',
            title: 'Plataforma Veeva',
            description: 'Ayuda visual interactiva de Cosentyx (secukinumab), enfocada en el tratamiento de enfermedades inflamatorias. El material presenta información médica y científica sobre eficacia, seguridad y beneficios del medicamento, utilizando elementos visuales para apoyar la educación y comunicación dirigida a profesionales de la salud.',
            thumbnail: '/Imagenes/ayudas visuales/imagenbanner.png',
            videoUrl: '/Imagenes/videos/video prueba Novartis.MOV',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 106,
            name: 'Ayuda visual Allegran',
            title: 'Plataforma Veeva',
            description: 'Ayuda visual de “Signature by Allergan Aesthetics”, enfocada en estética y cuidado de la sonrisa. El contenido presenta información promocional y educativa sobre oportunidades de mercado y soluciones estéticas, dirigido a profesionales del sector de la salud y estética.',
            thumbnail: '/Imagenes/ayudas visuales/veeva6.png',
            videoUrl: '/Imagenes/videos/video prueba Allegran.MOV',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 107,
            name: 'Pdf Allegran',
            title: 'Pdf Interactivo',
            description: 'PDF interactivo de Allegra enfocado en la rinitis alérgica y su impacto en la productividad y calidad de vida. El material presenta información educativa y promocional sobre síntomas, eficacia y beneficios del tratamiento mediante una navegación visual e interactiva dirigida a profesionales de la salud.',
            thumbnail: '/Imagenes/pdf/pdf1.png',
            videoUrl: '/Imagenes/pdf/Av Allegra Adultos CR 13-03-25 AG.pdf',
            width: '1024px',
            height: '768px',
            languages: ['Adobe'],
            url: '',
        },
        {
            id: 108,
            name: 'Ayuda visual durvalumab',
            title: 'Plataforma Veeva',
            description: 'Ayuda visual interactiva de Imfinzi (durvalumab) de AstraZeneca, enfocada en el tratamiento de primera línea para carcinoma hepatocelular irresecable (HCC). El material presenta información médica y científica sobre objetivos del tratamiento, diseño del estudio, dosis y mecanismos de acción, dirigido a profesionales de la salud como apoyo educativo y clínico.',
            thumbnail: '/Imagenes/ayudas visuales/veeva8.png',
            videoUrl: '/Imagenes/videos/Video Prueba Astrazeneca.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 109,
            name: 'Ayuda visual SYBRAVA',
            title: 'Plataforma Veeva Novartis',
            description: 'Ayuda visual interactiva de Novartis sobre SYBRAVA (inclisiran), enfocada en el control prolongado del colesterol LDL (C-LDL). El material presenta información médica y científica sobre eficacia, duración del tratamiento y beneficios terapéuticos, dirigido a profesionales de la salud como apoyo educativo y promocional.',
            thumbnail: '/Imagenes/ayudas visuales/nova1.png',
            videoUrl: '/Imagenes/videos/Video Prueba Novartis.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1010,
            name: 'Ayuda visual Opdivo',
            title: 'Plataforma Veeva Bristol',
            description: 'Ayuda visual interactiva de Opdivo (nivolumab) de Bristol Myers Squibb, enfocada en el tratamiento de tumores gastrointestinales. El material presenta información médica y científica sobre eficacia, práctica clínica, experiencia del paciente e indicaciones terapéuticas, dirigido a profesionales de la salud como apoyo educativo y clínico.',
            thumbnail: '/Imagenes/ayudas visuales/bristol.png',
            videoUrl: '/Imagenes/videos/Video Prueba Bristol.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1011,
            name: 'Ayuda visual Buscapina',
            title: 'Plataforma OCE',
            description: 'Ayuda visual interactiva de Buscapina y Buscomint, enfocada en el manejo del síndrome del intestino irritable (SII). El material presenta información médica y promocional sobre diagnóstico, eficacia, seguridad y beneficios de los tratamientos, dirigido a profesionales de la salud como apoyo educativo y comercial.',
            thumbnail: '/Imagenes/ayudas visuales/ayu1.png',
            videoUrl: '/Imagenes/videos/PideoPrueba - Buscamint.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1012,
            name: 'Ayuda visual Menticol',
            title: 'Plataforma OCE',
            description: 'Ayuda visual interactiva de Menticol CBD, enfocada en el alivio del dolor asociado a la práctica deportiva y lesiones musculares. El material presenta información educativa y promocional sobre dolor, actividad física y beneficios del producto, dirigido a profesionales de la salud como apoyo informativo y comercial.',
            thumbnail: '/Imagenes/ayudas visuales/menicol.png',
            videoUrl: '/Imagenes/videos/VideoPrueba - Menticol.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1013,
            name: 'Ayuda visual Takeda',
            title: 'Plataforma Veeva',
            description: 'Ayuda visual interactiva de Menticol CBD, enfocada en el alivio del dolor asociado a la práctica deportiva y lesiones musculares. El material presenta información educativa y promocional sobre dolor, actividad física y beneficios del producto, dirigido a profesionales de la salud como apoyo informativo y comercial.',
            thumbnail: '/Imagenes/ayudas visuales/sli21.png',
            videoUrl: '/Imagenes/videos/VideoPrueba - Takeda.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1014,
            name: 'Ayuda visual Amgen',
            title: 'Plataforma Veeva',
            description: 'La imagen muestra una ayuda visual médica de Amgen enfocada en programas de apoyo integral para pacientes tratados con panitumumab. Presenta servicios relacionados con diagnóstico, soporte al paciente y manejo de toxicidades, buscando fortalecer el acompañamiento y cuidado durante el tratamiento oncológico.',
            thumbnail: '/Imagenes/ayudas visuales/sfr3.png',
            videoUrl: '/Imagenes/videos/VideoPrueba - Amgen.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1015,
            name: 'Ayuda visual Blincyto',
            title: 'Plataforma Veeva',
            description: 'Instructivo para la preparación y administración de BLINCYTO.',
            thumbnail: '/Imagenes/ayudas visuales/blincyto.png',
            videoUrl: '/Imagenes/videos/VideoPrueba - Blincyto.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1016,
            name: 'Ayuda visual SUN PRO®',
            title: 'Plataforma Veeva',
            description: 'Protección solar para cada momento de la vida. Descubre el cuidado ideal para cada tipo de piel y necesidad diaria.',
            thumbnail: '/Imagenes/ayudas visuales/sunpo.png',
            videoUrl: '/Imagenes/videos/VideoPrueba - Bucaliv.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
        {
            id: 1017,
            name: 'Ayuda visual VECTIBIX®',
            title: 'Plataforma Veeva',
            description: 'Cada camino es único. Acompañando cada etapa con innovación y compromiso en el tratamiento.',
            thumbnail: '/Imagenes/ayudas visuales/slider0.png',
            videoUrl: '/Imagenes/videos/VideoPrueba - Vectibix.mp4',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3', 'JavaScript'],
            url: '',
        },
    ],
    approvedEmails: [{
            id: 201,
            name: 'Email Nplate',
            title: 'Plataforma Veeva',
            description: 'Es un documento o material guía que explica paso a paso cómo preparar y administrar correctamente el medicamento Nplate. Su objetivo es brindar apoyo visual y técnico a los profesionales de la salud para asegurar un uso adecuado, seguro y eficiente del tratamiento.',
            thumbnail: '/Imagenes/Rtes/rte1.png',
            videoUrl: '/Imagenes/Rtes/rte1.png',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3'],
            url: '',
        },
        {
            id: 202,
            name: 'Infografia',
            title: 'Plataforma Veeva',
            description: 'La NMO es una enfermedad autoinmune inflamatoria rara que afecta el sistema nervioso central.',
            thumbnail: '/Imagenes/Rtes/rte2.png',
            videoUrl: '/Imagenes/Rtes/rte2.png',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3'],
            url: '',
        },
        {
            id: 203,
            name: 'Email Opella',
            title: 'Plataforma Veeva',
            description: 'informativa del “Estudio PEGASO”, relacionada con Enterogermina y el uso de Bacillus clausii. El contenido presenta hallazgos y resultados de investigación sobre eficacia, síntomas, calidad de vida y seguridad del tratamiento, dirigido a profesionales de la salud como apoyo científico y educativo.',
            thumbnail: '/Imagenes/Rtes/rte3.png',
            videoUrl: '/Imagenes/videos/Video-Prueva- Mailchimp - RTE - Opella.mov',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3'],
            url: '',
        },
        {
            id: 204,
            name: 'Email Certican',
            title: 'Plataforma Veeva Novartis',
            description: 'Email” (correo activado remotamente) dentro de plataformas de marketing o automatización. En proyectos digitales también puede referirse a recursos enviados por correo interactivo, campañas médicas digitales o piezas visuales integradas en emails promocionales o educativos.',
            thumbnail: '/Imagenes/Rtes/rte4.png',
            videoUrl: '/Imagenes/videos/rte3.mov',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3'],
            url: '',
        },
        {
            id: 205,
            name: 'Email Novartis',
            title: 'Plataforma Veeva Novartis',
            description: 'Email evento médico llamado “El Poder de la Symplicidad”. El contenido presenta información sobre conferencistas, ciudad, lugar, fecha y horario del evento, dirigido a profesionales de la salud para promover la asistencia y participación.',
            thumbnail: '/Imagenes/Rtes/rte5.png',
            videoUrl: '/Imagenes/videos/VideoPrueba - Novartis RTE.mov',
            width: '1024px',
            height: '768px',
            languages: ['HTML5', 'CSS3'],
            url: '',
        },
    ],
}